<div class="my-3 my-md-5">
    <div class="container-fluid">
        <div class="col-sm-4 float-left">
            <h1 class="page-title" *ngIf="router.url == '/gp-leads'">GP Leads</h1>
            <h1 class="page-title" *ngIf="router.url != '/gp-leads'">Leads</h1>
        </div>
        <div class="col-sm-8 float-left add_lead_btn">
            
        </div>

    </div>

    <div class="container-fluid px-4 pt-4 card">
        <mat-accordion class="example-headers-align" multi>
                <mat-expansion-panel>
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                        <i class="fas fa-sliders-h"></i> <span class="pl-2">Filters</span>
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                    <div class="row mb-2 mt-2">
                        <div class="col-sm-2 mt-2"><input class="form-control" [(ngModel)]="search" type="text" placeholder="Search" /></div>
                        <div class="col-sm-2 mt-2" *ngIf="myrole!='2' && router.url != '/gp-leads'  && myrole!='16'">
                            <mat-select  placeholder="Lead Source" [(ngModel)]="lead_source" multiple>
                                <mat-option value="{{lsources.id}}" *ngFor="let lsources of lead_sources">{{lsources.source_name}}</mat-option>
                            </mat-select>
                        </div>
                        <div class="col-sm-2 mt-2">
                            <mat-select  placeholder="Lead Status" [(ngModel)]="lead_status" (click)="setSearchValue('lead_status')" multiple>
                                <input class="mySearchInput"
                                #lead_status_Search focused="'true'" type="text"
                                (keyup)="searchOnSelect($event.target.value, 'lead_status')"
                                (keydown)="$event.stopPropagation()" autocomplete="off"
                                placeholder="Search"
                                id="lead_status_Search">
                                <!-- <mat-option >All</mat-option> -->
                                <mat-option value="{{lstatus.id}}" *ngFor="let lstatus of leadStatus">{{lstatus.name}}</mat-option>
                            </mat-select>
                        </div>
                        <div class="col-sm-2 mt-2" *ngIf="myrole=='1' || myrole=='3' || myrole=='6' || myrole=='15' || myrole=='18'">
                            <mat-select  placeholder="Bds" [(ngModel)]="bd" (click)="setSearchValue('bds')" multiple #itemSelect="ngModel">
                                <input class="mySearchInput"
                                #bd_search focused="'true'" type="text"
                                (keyup)="searchOnSelect($event.target.value, 'bds')"
                                (keydown)="$event.stopPropagation()" autocomplete="off"
                                placeholder="Search"
                                id="bd_search">
                                <mat-option value="{{bd.id}}" *ngFor="let bd of bds">{{bd.name}}</mat-option>
                            </mat-select>
                        </div>
                        <div class="col-sm-2 mt-2">
                            <mat-select  placeholder="Circle" [(ngModel)]="circle" (click)="setSearchValue('circle')" multiple>
                                <input class="mySearchInput"
                                #circleSearch focused="'true'" type="text"
                                (keyup)="searchOnSelect($event.target.value, 'circle')"
                                (keydown)="$event.stopPropagation()" autocomplete="off"
                                placeholder="Search"
                                id="circleSearch">
                                <!-- <mat-option >All</mat-option> -->
                                <mat-option value="{{cir.id}}" *ngFor="let cir of circles">{{cir.name}}</mat-option>
                            </mat-select>
                        </div>
                        <div class="col-sm-2 mt-2">
                            <mat-select  placeholder="Treatment" [(ngModel)]="treatment" (click)="setSearchValue('treatment')" multiple>
                                <input class="mySearchInput"
                                #treatmentSearch focused="'true'" type="text"
                                (keyup)="searchOnSelect($event.target.value, 'treatment')"
                                (keydown)="$event.stopPropagation()" autocomplete="off"
                                placeholder="Search"
                                id="treatmentSearch">
                                <!-- <mat-option >All</mat-option> -->
                                <mat-option value="{{ltreatment.id}}" *ngFor="let ltreatment of treatments">{{ltreatment.name}}</mat-option>
                            </mat-select>
                        </div>
                        <div class="col-sm-2 mt-2" *ngIf="myrole!='14' && myrole!='16'">
                            <mat-select  placeholder="Bridge Number" [(ngModel)]="bridgeno">
                                <mat-option >All</mat-option>
                                <mat-option value="{{bnumbers.bridge_number}}" *ngFor="let bnumbers of bridge_number_lists">{{bnumbers.bridge_number}} ({{bnumbers.bridge_name}})</mat-option>
                            </mat-select>
                        </div>
                        <div class="col-sm-2 mt-2">
                            <mat-select  placeholder="Lead Catergory" [(ngModel)]="lead_category_filter" multiple>
                                <mat-option value="{{catergory.id}}" *ngFor="let catergory of treatCategory">{{catergory.name}}</mat-option>
                            </mat-select>
                        </div>
                        
                        <div class="col-sm-2 mt-2">
                            <mat-select  placeholder="Payment Mode"  [(ngModel)]="payment_mode" multiple>
                                <!-- <mat-option >All</mat-option> -->
                                <mat-option value="Cash">Cash</mat-option>
                                <mat-option value="Cashless">Cashless</mat-option>
                                <mat-option value="Reimbursement">Reimbursement</mat-option>
                                <mat-option value="EMI">EMI</mat-option>
                            </mat-select>
                        </div>
                        <div class="col-sm-2 mt-2">
                            <mat-select placeholder="Gender"  [(ngModel)]="gender">
                                <mat-option value="">All</mat-option>
                                <mat-option value="Male">Male</mat-option>
                                <mat-option value="Female">Female</mat-option>
                            </mat-select>
                        </div>
                        <div class="col-sm-2 mt-2">
                            <mat-select  placeholder="Pre-Sales Users" [(ngModel)]="pre_sale_users_filter" multiple>
                                <mat-option value="{{psu.id}}" *ngFor="let psu of allpre_sale_users">{{psu.name}}</mat-option>
                            </mat-select>
                        </div>
                    </div>
                    <div class="row">
                        
                        <div class="col-sm-3 mt-2">
                            <mat-form-field appearance="fill">
                                <mat-label>Enter a date range</mat-label>
                                <mat-date-range-input [rangePicker]="picker">
                                    <input matStartDate #dateRangeStart placeholder="Start date">
                                    <input matEndDate #dateRangeEnd placeholder="End date" (dateChange)="dateRangeChange(dateRangeStart, dateRangeEnd)">
                                </mat-date-range-input>
                                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                <mat-date-range-picker #picker></mat-date-range-picker>
                            </mat-form-field>
                            <mat-icon (click)="clearDate()">clear</mat-icon>
                        </div>
                        <div class="col-sm-3 mt-2">
                            <mat-form-field appearance="fill">
                                <mat-label>Enter Follow-Up date range</mat-label>
                                <mat-date-range-input [rangePicker]="picker1">
                                    <input matStartDate #followupdateRangeStart placeholder="Start date">
                                    <input matEndDate #followupdateRangeEnd placeholder="End date" (dateChange)="dateRangeChangefollowUp(followupdateRangeStart, followupdateRangeEnd)">
                                </mat-date-range-input>
                                <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                                <mat-date-range-picker #picker1></mat-date-range-picker>
                            </mat-form-field>
                            <mat-icon (click)="clearDateFollowUp()">clear</mat-icon>
      
                            </div>

                        <div class="float-right mt-6" *ngIf="myrole!='14'">
                            <label class="custom-control custom-checkbox">
                                <input type="checkbox" class="custom-control-input" [(ngModel)]="showopdDonebutIpdNotDone">
                                <span class="custom-control-label">Show Opd done but Ipd not done</span>
                              </label>
                        </div>
                        <div class="col-sm-3 mt-6" *ngIf="myrole=='1' || myrole=='3' || myrole=='6' || myrole=='18'">
                          <label class="custom-control custom-checkbox">
                              <input type="checkbox" class="custom-control-input"  [(ngModel)]="displayInactiveUsersLead" />
                              <span class="custom-control-label">Display Inactive Users Lead</span>
                          </label>
                       </div>

                       <div class="col-sm-3 mt-2">
                        <label class="custom-control custom-checkbox">
                            <!-- <input type="checkbox" class="custom-control-input" /> -->
                          <input type="checkbox" class="custom-control-input"  [(ngModel)]="c2ckalerarecording" />
                          <span class="custom-control-label" style="color:black">Display C2C Recording Leads</span>
                        </label>
                    </div>
    
                       <div class="col-sm-3 mt-2">
                        <button type="button" class="btn btn-primary ml-2 mb-4" (click)="loadleads(0,perpage)"> <i class="fa fa-search" aria-hidden="true"></i> Search Data</button>
                        <button type="button" class="btn btn-primary ml-2 mb-4" (click)="resetFilters()"> <i class="fa fa-sync"></i> Reset Filters</button>
                      </div>
                      
                       
                    </div>
                </mat-expansion-panel>
        </mat-accordion>
        <div class="card">
            <div class="container-fluid row">
                <div class="col-sm-8 p-3"><button type="button" class="btn btn-success" [disabled]="loading" (click)="loadleads(0,perpage)"><i class="fa fa-sync" [ngClass]="{'fa-spin':loading}"></i> Refresh List</button>
                    
                <button type="button" *ngIf="(myrole=='1' || myrole=='15')" class="btn btn-success ml-2" [disabled]="loading" (click)="exportTrainingLeadData()"><i class="fa fa-file-excel"></i> Export For Q&T</button>

                 </div>
                <div class="col-sm-4"><mat-paginator #paginatorTop [length]="length" [pageSizeOptions]="pageSizeOptions" [pageSize]="perpage" (page)="pageEvent = getServerData($event);paginatorBottom.pageIndex = $event.pageIndex"></mat-paginator></div>
            </div>
            <div class="tableFixHead" style="overflow: scroll">
            <table class="table table-striped">
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Lead Id</th>
                        <th>Patient Id</th>
                        <th>Glamyo Patient Id</th>
                        <th *ngIf="myrole!='2'">Lead Source</th>
                        <th>Bridge Number</th>
                        <th>Lead Status</th>
                        <th>Payment Mode</th>
                        <!-- <th>POLICY NUMBER</th> -->
                        <th class="tablefixcoloumn">Lead Name</th>
                        <!-- <th width="100" *ngIf="userId!='16' && myrole!='12' && myrole!='6' && myrole!='18' && myrole!='2' && myrole!='3'">Lead Mobile</th> -->
                        <!-- <th>Age</th> -->
                        <!-- <th>Gender</th> -->
                        <th>Lead Location</th>
                        <!-- <th>Sub Location</th> -->
                        <th>Circle</th>
                        <th>Lead Owner</th>
                        <th>Employee Id</th>
                        <th>Treatment</th>
                        <th>Treatment Catergory</th>
                        <!-- <th>Problem</th> -->
                        <th width="500">Description</th>
                        <!-- <th colspan="3">
                            Call Details
                        </th> -->
                        <th>C2C Recording</th>
                        <th>Lead Time</th>
                        <th>Surgery Time</th>
                        <th>Follow Up Date</th>
                        <th *ngIf="myrole!='2'">Form Lead Source</th>
                        <!-- <th *ngIf="myrole!='2'">Form Ad Type</th> -->
                        <!-- <th *ngIf="myrole!='2'">Form GCLID</th> -->
                        <!-- <th *ngIf="myrole!='2'">Form Keywords</th> -->
                        <!-- <th *ngIf="myrole!='2'">Campaign Name</th> -->
                        <!-- <th *ngIf="myrole!='2'">Site</th> -->
                        <!-- <th *ngIf="myrole!='2'">Thumbnail</th> -->
                        <!-- <th *ngIf="myrole!='2'">Promo Code</th> -->
                        <!-- <th *ngIf="myrole!='2'">Ad GroupID</th> -->
                        <!-- <th *ngIf="myrole!='2'">Match Type</th> -->
                        <th *ngIf="myrole!='4' && myrole!='9' && myrole!='12' && myrole!='13'">Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let lead of leads;let index = index;" [ngClass]="{'labLeads':(lead.lead_source==7 && (lead.referral_type==6 || lead.referral_type==7))}">
                        <td >{{(pageIndex*perpage)+index+1}}</td>
                        <td>{{lead.id}}</td>
                        <td>{{lead.patient_id}}</td>
                        <td>{{lead.glamyo_patient_id}}</td>
                        <td *ngIf="myrole!='2'">
                            <span class="badge bg-green-light" *ngIf="lead.lead_source==2">{{lead.source_name}}</span>
                            <span class="badge bg-indigo-light" *ngIf="lead.lead_source!=2">{{lead.source_name}}
                            </span> <br>
                            <span  *ngIf="lead.referral_type">
                                <span>({{getRefferalType(lead.referral_type)}} - {{lead.referral_person_name}})</span> <br>
                            </span>
                        </td>
                        <td>{{lead.bridge_no}}</td>
                        <td>
                            <span class="badge bg-azure-light">{{lead.lead_status_name}}</span>
                        </td>
                        <td>{{lead.payment_mode}}</td>
                        <!-- <td>{{lead.policy_number}}</td> -->
                        <td class="tablefixcoloumn">{{lead.lead_name}}</td>
                        <!-- <td width="100" *ngIf="userId!='16'  && myrole!='12' && myrole!='6' && myrole!='18' && myrole!='2' && myrole!='3'">
                            <div style="width: 150px;">
                                <span *ngIf="!showNumberArray[index]">********** &nbsp; 
                                    <i (click)="showhideNumber('1',index)" class="fa fa-eye" aria-hidden="true" *ngIf="!showNumberArray[index]"></i>
                                    
                                </span>
                                <span *ngIf="showNumberArray[index]">
                                    {{lead.mobile}} &nbsp;
                                    <i (click)="showhideNumber('2',index)" class="fa fa-eye-slash" aria-hidden="true" *ngIf="showNumberArray[index]"></i>
                                </span>
                            </div>
                        </td> -->
                        <!-- <td>{{lead.patient_age}}</td> -->
                        <!-- <td>{{lead.gender}}</td> -->
                        <td>{{lead.city_name}}</td>
                        <!-- <td>
                            <span *ngIf="lead.sub_location">{{lead.sub_location}}</span>
                            <span *ngIf="!lead.sub_location">-</span>
                        </td> -->
                        <td>{{lead.circle_name}}</td>
                        <td>{{lead.bd_name}}</td>
                        <td>{{lead.employee_id}}</td>
                        <td>{{lead.treatment_name}}</td>
                        <td>{{lead.catergoryName}}</td>
                        <!-- <td>{{lead.problem}}</td> -->
                        <td width="500" style="display: inline-block;">{{lead.description}}</td>
                        <!-- <td colspan="3">
                            <table class="table table-bordered">
                                <tbody>
                                    <tr *ngFor="let callD of toJson(lead.call_details)">
                                        <td>
                                            <span *ngIf="lead.lead_source==2 && callD.call_start_time">{{callD.call_start_time*1000|date:'d MMM, yyyy H:m:s'}}</span>
                                            <span *ngIf="lead.lead_source==1">NA</span>
                                        </td>
                                        <td>
                                            <span *ngIf="lead.lead_source==2 && callD.call_end_time">{{callD.call_end_time*1000|date:'d MMM, yyyy H:m:s'}}</span>
                                            <span *ngIf="lead.lead_source==1">NA</span>
                                        </td>
                                        <td>
                                            <span *ngIf="lead.lead_source==2 && callD.call_recording_url"><a target="_blank" href="{{callD.call_recording_url}}">View Recording</a></span>
                                            <span *ngIf="(lead.lead_source==2 && !callD.call_recording_url) || lead.lead_source==1">NA</span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </td> -->
                        <td [innerHTML]="lead.click_to_call_recording"></td>
                        <td>{{lead.lead_time*1000|date:'d MMM, yyyy H:m:s'}}</td>
                        <td>
                            <span *ngIf="lead.ipd_surgery_date">{{lead.ipd_surgery_date*1000|date:'d MMM, yyyy H:m:s'}}</span>
                            <span *ngIf="!lead.ipd_surgery_date">-</span>
                        </td>
                        <td>
                            <span *ngIf="lead.followup_date">{{lead.followup_date*1000|date:'d MMM, yyyy H:m:s'}}</span>
                            <span *ngIf="!lead.followup_date">-</span>
                        </td>
                        <td *ngIf="myrole!='2'">
                            <span *ngIf="lead.zoho_lead_source">{{lead.zoho_lead_source}}</span>
                            <span *ngIf="!lead.zoho_lead_source">NA</span>
                        </td>
                        <!-- <td *ngIf="myrole!='2'">
                            <span *ngIf="lead.zoho_ad_type">{{lead.zoho_ad_type}}</span>
                            <span *ngIf="!lead.zoho_ad_type">NA</span>
                        </td> -->
                        <!-- <td *ngIf="myrole!='2'">
                            <span *ngIf="lead.gclid">{{lead.gclid}}</span>
                            <span *ngIf="!lead.gclid">NA</span>
                        </td> -->
                        <!-- <td *ngIf="myrole!='2'">
                            <span *ngIf="lead.keywords">{{lead.keywords}}</span>
                            <span *ngIf="!lead.keywords">NA</span>
                        </td> -->
                        <!-- <td *ngIf="myrole!='2'">
                            <span *ngIf="lead.campaign_name">{{lead.campaign_name}}</span>
                            <span *ngIf="!lead.campaign_name">-</span>

                        </td> -->

                        <!-- <td *ngIf="myrole!='2'">
                            <span *ngIf="lead.utm_site">{{lead.utm_site}}</span>
                            <span *ngIf="!lead.utm_site">-</span>

                        </td> -->

                        <!-- <td *ngIf="myrole!='2'">
                            <span *ngIf="lead.thumbnail">{{lead.thumbnail}}</span>
                            <span *ngIf="!lead.thumbnail">-</span>

                        </td> -->
                        <!-- <td *ngIf="myrole!='2'">
                            <span *ngIf="lead.promocode">{{lead.promocode}}</span>
                            <span *ngIf="!lead.promocode">-</span>

                        </td> -->
                        <!-- <td *ngIf="myrole!='2'">
                            <span *ngIf="lead.utm_agid">{{lead.utm_agid}}</span>
                            <span *ngIf="!lead.utm_agid">-</span>

                        </td> -->
                        <!-- <td *ngIf="myrole!='2'">
                            <span *ngIf="lead.matchtype">{{lead.matchtype}}</span>
                            <span *ngIf="!lead.matchtype">-</span>

                        </td> -->

                        <td  *ngIf="myrole!='4' && myrole!='9' && myrole!='12' && myrole!='13'">
                             <div class="dropdown">
                                <button class="btn btn-secondary dropdown-toggle" type="button" id="{{lead.id}}" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    Action
                                </button>
                                <div class="dropdown-menu" aria-labelledby="{{lead.id}}">
                                    <a class="dropdown-item" target="_blank" routerLink="/view-lead/{{lead.id}}"><i class="fa fa-eye"></i> View</a>
                                    <!-- <a *ngIf="myrole!='6'" class="dropdown-item" (click)="getPaymentTreatmentStatus(lead.id,'Upload Insurance Card')"><i class="fa fa-file-medical"></i> Upload Insurance Card</a>
                                    <a *ngIf="myrole!='6'" class="dropdown-item" (click)="getPaymentTreatmentStatus(lead.id,'Post OPD')"><i class="fa fa-stethoscope"></i> Post OPD</a>
                                    <a *ngIf="myrole!='6'" class="dropdown-item" (click)="getPaymentTreatmentStatus(lead.id,'Post IPD')"><i class="fa fa-clinic-medical"></i> Post IPD</a>
                                    <a *ngIf="myrole!='6'" class="dropdown-item" (click)="getPaymentTreatmentStatus(lead.id,'Create Duplicate Lead')"><i class="far fa-copy"></i> Create Duplicate Lead</a> -->
                                    <!-- <a class="dropdown-item" href="#" routerLink="/update-lead/{{lead.id}}"><i class="fa fa-pen"></i> Update</a> -->
                                    <!-- <a *ngIf="myrole!='6'" class="dropdown-item" href="#"><i class="fa fa-trash"></i> Delete</a> -->
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr *ngIf="loading">
                        <td colspan="21" class="text-center"><i class="fa fa-spin fa-spinner fa-2x"></i></td>
                    </tr>
                    <tr *ngIf="loaded && !leads.length">
                        <td colspan="21" ><i class="far fa-frown"></i> Leads not found</td>
                    </tr>
                </tbody>
            </table>
            </div>
            <mat-paginator #paginatorBottom [length]="length" [pageSizeOptions]="pageSizeOptions" [pageSize]="perpage" (page)="pageEvent = getServerData($event);paginatorTop.pageIndex = $event.pageIndex"></mat-paginator>
        </div>


          </div>
</div>
<!-- FB import modal -->
<!-- The Modal -->
<div class="modal fade" id="myModalfb">
    <div class="modal-dialog">
      <div class="modal-content">
  
        <!-- Modal Header -->
        <div class="modal-header">
          <h4 class="modal-title">Import Fb Data </h4>
          <button type="button" class="close" (click)="hideModalFb()"></button>
        </div>
  
        <!-- Modal body -->
          <div class="modal-body">
              <div class="form-group">
                  <div class="row">
                      <label class="col-sm-12">Upload CSV</label>
                      <input [disabled]="submitted" type="file" #csvUploadFb (change)="selectFileFb($event)" class="form-control" />
                  </div>
                  <span *ngIf="submitted"><i class="fa fa-spin fa-spinner"></i> Uploading...</span>
              </div>
          </div>
  
        <!-- Modal footer -->
        <div class="modal-footer">
          <button type="button" class="btn" (click)="hideModalFb()">Close</button>
        </div>
      </div>
    </div>
  </div>


 <!-- partners import modal -->
<!-- The Modal -->
<div class="modal fade" id="myModalpartners">
    <div class="modal-dialog">
      <div class="modal-content">
  
        <!-- Modal Header -->
        <div class="modal-header">
          <h4 class="modal-title">Import Partners Data </h4>
          <button type="button" class="close" (click)="hideModalPartner()"></button>
        </div>
  
        <!-- Modal body -->
          <div class="modal-body">
              <div class="form-group">
                  <div class="row">
                      <label class="col-sm-12">Upload CSV</label>
                      <input [disabled]="submittedPartners" type="file" #csvUploadPartners (change)="selectFilePartners($event)" class="form-control" />
                  </div>
                  <span *ngIf="submittedPartners"><i class="fa fa-spin fa-spinner"></i> Uploading...</span>
              </div>
          </div>
  
        <!-- Modal footer -->
        <div class="modal-footer">
          <button type="button" class="btn" (click)="hideModalPartner()">Close</button>
        </div>
      </div>
    </div>
  </div> 


<!-- The Modal -->
<div class="modal fade" id="myModal">
  <div class="modal-dialog">
    <div class="modal-content">

      <!-- Modal Header -->
      <div class="modal-header">
        <h4 class="modal-title">Import Data </h4>
        <button type="button" class="close" (click)="hideModal()"></button>
      </div>

      <!-- Modal body -->
        <div class="modal-body">
            <div class="form-group">
                <div class="row">
                    <label class="col-sm-12">Upload CSV</label>
                    <input [disabled]="submitted" type="file" #csvUpload (change)="selectFile($event)" class="form-control" />
                </div>
                <span *ngIf="submitted"><i class="fa fa-spin fa-spinner"></i> Uploading...</span>
            </div>
        </div>

      <!-- Modal footer -->
      <div class="modal-footer">
        <button type="button" class="btn" (click)="hideModal()">Close</button>
      </div>
    </div>
  </div>
</div>
<!-- Duplicate Modal -->
<div class="modal fade" id="duplicateModal">
    <div class="modal-dialog">
      <div class="modal-content">

        <!-- Modal Header -->
        <div class="modal-header">
          <h4 class="modal-title">Create Duplicate Lead</h4>
          <button type="button" class="close" (click)="hideduplicateModal()"></button>
        </div>

        <!-- Modal body -->
          <div class="modal-body">
              <div class="form-group">
                  <div class="row">
                    <div class="col-sm-12"><h2>Do you want to create duplicate lead?</h2></div>

                    <div *ngIf="copyData" class="col-sm-12 text-center" style="font-size: 22px;"><span><i class="fa fa-spin fa-spinner"></i> Uploading...</span></div>

                  </div>

              </div>
          </div>

        <!-- Modal footer -->
        <div class="modal-footer">
           <button type="button" class="btn btn-success" (click)="copyLead()">Confirm</button>
          <button type="button" class="btn" (click)="hideduplicateModal()">Close</button>
        </div>
      </div>
    </div>
  </div>

   <!--For Show Payment Mode and Treatment not Selected Modal -->
<div class="modal fade" id="paymentTreatmentModal">
    <div class="modal-dialog">
      <div class="modal-content">

        <!-- Modal Header -->
        <div class="modal-header">
          <h4 class="modal-title" style="font-weight: bold;">Action Required</h4>
          <button type="button" class="close" (click)="hideStatusModal()"></button>
        </div>

        <!-- Modal body -->
          <div class="modal-body">
                <div class="form-group">
                  <div class="row">
                    <div style="font-size: 18px;" class="col-sm-12 modal-title" id="StatusText"><h2></h2></div>
                  </div>
                </div>
          </div>

        <!-- Modal footer -->
        <div class="modal-footer">
          <button type="button" class="btn" (click)="hideStatusModal()">Close</button>
        </div>
      </div>
    </div>
  </div>

<!--------For Lead Dump Data-------------->
<div class="modal fade" id="leadDumpData" data-backdrop="static" data-keyboard="false">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">

        <!-- Modal Header -->
        <div class="modal-header">
            <h4 class="modal-title">Lead Dump </h4>
            <button type="button" class="close" (click)="hideModalLeadDump()"></button>
        </div>

        <!-- Modal body -->
            <div class="modal-body">
                <div class="form-group">
                    <div class="row">
                        <div class="col-md-12 text-danger"><b>Note*** : </b> Date selection should be 31 days or less than 31 days</div>
                    </div>
                    <div class="row">
                        <div class="col-sm-5 mt-2">
                            <mat-form-field appearance="fill">
                                <mat-label>Enter a date range</mat-label>
                                <mat-date-range-input [rangePicker]="dump_picker">
                                    <input matStartDate #dateRangeStartDump placeholder="Start date">
                                    <input matEndDate #dateRangeEndDump placeholder="End date" (dateChange)="dateRangeChangeDump(dateRangeStartDump, dateRangeEndDump)">
                                </mat-date-range-input>
                                <mat-datepicker-toggle matSuffix [for]="dump_picker"></mat-datepicker-toggle>
                                <mat-date-range-picker #dump_picker></mat-date-range-picker>
                            </mat-form-field>
                            <mat-icon style="font-size: 20px;" (click)="clearDateDump()">clear</mat-icon>
                        </div>
                        <div class="col-sm-2 mt-4">
                            <label class="custom-control custom-checkbox">
                                <input type="checkbox" class="custom-control-input" [(ngModel)]="export_dump_with_kalera_call">
                                <span class="custom-control-label">Export with Kalera Recording</span>
                            </label>
                        </div>
                        <div class="col-sm-2 mt-4">
                            <label class="custom-control custom-checkbox">
                                <input type="checkbox" class="custom-control-input" [(ngModel)]="export_dump_with_c2c">
                                <span class="custom-control-label">Export with C2C Recording</span>
                            </label>
                        </div>
                        <div class="col-sm-2 mt-4">
                            <button  [disabled]="dump_loading" type="button" class="btn btn-success" (click)="getleaddumpByDate()">Get Export List</button>
                        </div>
                    </div>
                </div>
                <hr>
                <div *ngIf="dump_total>0">
                    <div [innerHTML]="paging_html_dump | safe:'html'"></div>
                </div>
            </div>

        <!-- Modal footer -->
        <div class="modal-footer">
            <button type="button" class="btn" (click)="hideModalLeadDump()">Close</button>
        </div>
        </div>
    </div>
</div>
